module.exports = __webpack_public_path__ + "img/increase-font-size.d996e732.svg";